export default __webpack_public_path__ + "7b61ffbf9abb0a548d770b0db2d6d396.png";